/* LUGNA by LINTEL PDP: gallery (counter/thumbs), review slider, load more, sticky ATC, every add -> LGN brand cart drawer (never /cart) */
(function () {
  var tr = document.querySelector('[data-lgn-track]'), thumbs = document.querySelector('[data-lgn-thumbs]'), cnt = document.querySelector('[data-lgn-gcount]');
  function go(k) { if (tr) tr.scrollTo({ left: k * tr.clientWidth, behavior: 'smooth' }); }
  function upd() {
    if (!tr) return;
    var n = tr.children.length, i = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth));
    if (cnt) cnt.textContent = (i + 1) + ' / ' + n;
    if (thumbs) thumbs.querySelectorAll('button').forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
  }
  if (tr) {
    if (thumbs) thumbs.querySelectorAll('button').forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
    tr.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
    upd();
  }
  document.querySelectorAll('[data-lgn-rs]').forEach(function (c) {
    var t = c.querySelector('.lgn-rs__track');
    c.querySelectorAll('.lgn-rs__nav button').forEach(function (b) { b.addEventListener('click', function () { t.scrollBy({ left: +b.dataset.d * t.clientWidth * 0.85, behavior: 'smooth' }); }); });
  });
  var more = document.querySelector('[data-lgn-more]'), list = document.querySelector('[data-lgn-rlist]');
  if (more && list) more.addEventListener('click', function () { list.classList.add('is-all'); more.style.display = 'none'; });
  var form = document.getElementById('lgn-buy');
  document.querySelectorAll('[data-lgn-top]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault(); var t = document.querySelector('.kaching-bundles') || form;
      if (t) window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 110, behavior: 'smooth' });
    });
  });
  /* Kaching colour choice -> show that colour's hero (1 Solis gold, 2 Perla, 3 Flora, 4 Solis silver) */
  document.addEventListener('change', function (e) {
    var s = e.target; if (!s || !s.closest || !s.closest('.kaching-bundles') || s.tagName !== 'SELECT') return;
    var t = (s.options[s.selectedIndex] || {}).text || '';
    if (/perla/i.test(t)) go(1); else if (/flora/i.test(t)) go(2); else if (/silver/i.test(t)) go(3); else if (/solis|gold/i.test(t)) go(0);
  }, true);
  var st = document.querySelector('[data-lgn-sticky]');
  if (st && form && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { st.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }).observe(form);
  }
  var sa = document.querySelector('[data-lgn-sticky-atc]');
  if (sa && form) sa.addEventListener('click', function () {
    if (form.requestSubmit) form.requestSubmit(); else form.querySelector('[type=submit]').click();
  });
})();

/* Add to cart NEVER goes to /cart (Edvin 10-02): every /cart/add form opens the LGN brand cart drawer */
(function () {
  if (window.__lgn_atc) return; window.__lgn_atc = 1;
  function open() { if (window.LGN && window.LGN.openCart) return window.LGN.openCart(); }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    if (e.defaultPrevented) return;
    e.preventDefault();
    var b = f.querySelector('[type=submit]'); if (b) b.disabled = true;
    var fd = new FormData(f), tries = 0;
    (function add() {
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) {
          if (r.ok) { if (b) b.disabled = false; return open(); }
          if (r.status === 422) return r.json().then(function (j) { if (b) b.disabled = false; open(); if (j && j.description) alert(j.description); });
          throw new Error('add ' + r.status);
        })
        .catch(function () { if (++tries < 5) return setTimeout(add, 1000 * tries); if (b) b.disabled = false; open(); alert('Sorry, that did not go through - please tap Add to cart again.'); });
    })();
  }, false);
})();
